export { EmployeeDetail } from './EmployeeDetail';
